import { Component, OnInit, EventEmitter, Input } from '@angular/core';

export interface ActionButton {
  icon: string
  tooltip: string
  eventEmitter: EventEmitter<ActionButtonEvent>
}

export interface ActionButtonEvent {
  event: Event
  actionButtonIndex: number
  eventData: any
}

@Component({
  selector: 'app-action-button-toolbar',
  templateUrl: './action-button-toolbar.component.html',
  styleUrls: ['./action-button-toolbar.component.css']
})
export class ActionButtonToolbarComponent implements OnInit {

  //@Input() actionButtonEvents: EventEmitter<{}>[];
  @Input() actionButtons: ActionButton[];
  @Input() eventData: any;

  constructor() { }

  ngOnInit() {
  }

  actionTriggeredHandler($event: Event, actionButtonIndex: number) {
    $event.stopPropagation();
    if (this.actionButtons[actionButtonIndex].eventEmitter)
      this.actionButtons[actionButtonIndex].eventEmitter.emit(
        { event: $event, actionButtonIndex, eventData: this.eventData }
      );
  }

}
